import { useState, useEffect } from 'react';
import { TextField, Icon } from '@a-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTaskNotes, addTaskNote } from '../../store/slices/tasksReducer'
import Spinner from '../Spinner/Spinner';

const Notes = (props) => {
  const dispatch = useDispatch();
  const [content, setContent] = useState("");
  const { notes, notesLoading } = useSelector(state => state.tasks);
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchTaskNotes(props.taskId));
  }, [dispatch, props.taskId]);

  const onFormSubmit = e => {
    e.preventDefault();
    if (!content) return false;
    dispatch(addTaskNote({
      id: props.taskId,
      name: `${user.firstName} ${user.lastName}`,
      content,
    })).then(() => {
      dispatch(fetchTaskNotes(props.taskId)).then(() => {
        setContent('');
      })
    });
  }

  return (<div className="o-notes u-margin-bottom-xl">
    <ul className="a-list a-list--lined a-list--flushed">
    { notes && [...notes].reverse().map((note) => {
      return <li key={note.id} className="a-list__item">
        <div className="a-list__content">
          <strong>{ note.name }</strong><br/>
          <small className="u-text-light">{ new Date(note.createdAt + 'Z').toLocaleTimeString([], {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'}) }</small><br/>
          { note.content }
        </div>
      </li>
    }) }
    </ul>
    <form className="a-input__wrapper o-notes--flex u-margin-top" onSubmit={onFormSubmit}>
      <TextField
        id="notes"
        label="Nieuwe notitie"
        value={content}
        onChange={e => {setContent(e.target.value)}}
      />
      <button
        type="submit"
        className="a-button u-margin-left-xs has-icon"
        aria-label="Notitie verzenden"
      >
        { notesLoading === "loading" && <Spinner>Aan het laden …</Spinner> }
        { notesLoading !== "loading" && <Icon name="ai-send-email"/>}
      </button>
    </form>
  </div>);
};

export default Notes;
